// @flow
import ThemeProvider from '@tablekit/theme/ThemeProvider';
import type { HeaderType } from 'components/types';
import { useEffect } from 'react';
import Nav from '../components/Nav';

type PropsType = {
  pageContext: {
    hasCountrySpecificAlternates: boolean,
    header: HeaderType,
    links: string[],
    useRelativeRedirect: boolean
  },
  path: string
};

function checkAppLoaded(pageContext, useRelativeRedirect) {
  if (window.isAppReady) return;
  window.tsWebsiteLocaleDetection(pageContext, useRelativeRedirect);
}

export default function I18nRedirect({
  pageContext: {
    header,
    links,
    hasCountrySpecificAlternates,
    useRelativeRedirect
  },
  path
}: PropsType) {
  useEffect(() => {
    const redirectContext = {
      links: {
        alternates: links.map((url) => {
          if (typeof url !== 'string') return url;
          const [, lang] = url.split('/');
          return {
            lang,
            href: url,
            slug: url
          };
        }),
        hasCountrySpecificAlternates
      },
      story: { full_slug: path.replace(/\/[*]+\//gi, '/') }
    };
    // the following is a check for dev mode, in the build this is injected via SSR
    if (!window.tsWebsiteLocaleDetection) {
      import('../utils/localeDetection').then(() => {
        checkAppLoaded(redirectContext, useRelativeRedirect);
      });
    } else {
      checkAppLoaded(redirectContext, useRelativeRedirect);
    }
  });
  return (
    <ThemeProvider fontWeights={[]}>
      <Nav
        isWhiteOnly
        countries={[]}
        countryLinks={{
          alternates: [],
          canonical: path,
          genericSlug: path,
          hasCountrySpecificAlternates
        }}
        path={path}
        homeUrl={path}
        header={{ ...header, hide_language_switcher: true }}
      />
    </ThemeProvider>
  );
}
